import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import MyApp from "./MyApp";
import User from "./User";
import Dashboard from "./Dashboard";
import SideMenu from "../customComponents/SideMenu";
import LoyaltyPoints from "./LoyaltyPoints";
import Statement from "./Statement";
import CustomerProfile from "./CustomerProfile";
import MessageConfiguration from "./MessageConfiguration";
import SchemeGeneration from "./SchemeGeneration";
import SchemeStatement from "./SchemeStatement";
import AlertBox from "../customComponents/AlertBox";
import Footer from "../customComponents/Footer";
import SchemeSummary from "./SchemeSummary";
import StorePrices from "./StorePrices";

const Home = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="flex h-screen bg-white">
      <div className="hidden lg:block lg:min-w-[250px] lg:h-full">
        <SideMenu
          isMobileMenuOpen={isMobileMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
          toggleMobileMenu={toggleMobileMenu}
          closeMobileMenu={closeMobileMenu}
        />
      </div>
      <div className="lg:hidden">
        <SideMenu
          isMobileMenuOpen={isMobileMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
          toggleMobileMenu={toggleMobileMenu}
          closeMobileMenu={closeMobileMenu}
        />
      </div>
      <div className="relative w-full overflow-auto">
        <AlertBox />
        <Routes>
          <Route path="/" element={<Dashboard toggleMobileMenu={toggleMobileMenu}/>} />
          <Route path="store-prices" element={<StorePrices toggleMobileMenu={toggleMobileMenu}/>} />
          <Route path="mobile-app" element={<MyApp toggleMobileMenu={toggleMobileMenu}/>} />
          <Route path="customer-profile" element={<CustomerProfile toggleMobileMenu={toggleMobileMenu}/>} />
          <Route path="loyalty-points" element={<LoyaltyPoints toggleMobileMenu={toggleMobileMenu}/>} />
          <Route path="scheme-generation" element={<SchemeGeneration toggleMobileMenu={toggleMobileMenu}/>} />
          <Route path="message-configuration" element={<MessageConfiguration toggleMobileMenu={toggleMobileMenu}/>}/>
          <Route path="user" element={<User toggleMobileMenu={toggleMobileMenu}/>} />
          <Route path="statement" element={<Statement toggleMobileMenu={toggleMobileMenu}/>} />
          <Route path="scheme-statement" element={<SchemeStatement toggleMobileMenu={toggleMobileMenu}/>} />
          <Route path="scheme-summary" element={<SchemeSummary toggleMobileMenu={toggleMobileMenu}/>} />
        </Routes>
        <Footer />
      </div>
    </div>
  );
};

export default Home;
